var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.153547 2.74152C0.0364107 2.7254 -0.0346391 2.57106 0.0172082 2.44207C0.209235 1.96063 0.520319 1.98366 0.802599 1.97906C2.28121 1.95372 3.75981 1.9445 5.23842 1.93299C5.82218 1.92838 6.40594 1.93299 7.04731 1.93299C6.92633 1.50223 6.58261 1.47228 6.35409 1.28569C6.10062 1.07838 5.8145 0.924041 5.57831 0.695992C5.49381 0.613065 5.45349 0.336642 5.50534 0.221465C5.56102 0.0970749 5.75113 -0.00658385 5.87787 0.000326729C6.05453 0.00954084 6.2312 0.117807 6.39826 0.207644C7.43905 0.765098 8.47407 1.33177 9.51486 1.88922C9.77985 2.03204 10.0641 2.2025 9.98724 2.5941C9.93924 2.84288 9.75681 3.11009 9.57439 3.25521C9.32283 3.45331 9.01367 3.55006 8.72563 3.68136C7.94984 4.03841 7.17213 4.38855 6.39634 4.7479C6.05837 4.90454 5.64552 5.23624 5.41124 4.72947C5.14625 4.15359 5.63015 3.90941 5.9566 3.64911C6.1083 3.52933 6.26576 3.42106 6.57301 3.19762C4.38006 2.79451 2.28505 3.03407 0.153547 2.74152Z",
    fill: "#73BE2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.7288156e9152acaddd47b445142de4f0.svg";
export { ForwardRef as ReactComponent };